import { action, ObservableSet } from "mobx";
import { observer } from "mobx-react-lite";

import { FontIcon, Image, Link, Stack, StackItem } from "@bps/fluent-ui";

import openInNewTabSvg from "./assets/OpenInNewTab.svg";
import { getXeroLinkUrl } from "./XeroSyncHistoryListItem.utils.ts";
import { XeroFinancialSyncOperationListItem } from "./XeroSyncHistoryListRow.tsx";

interface XeroSyncHistoryItemIconsProps {
  operation: XeroFinancialSyncOperationListItem;
  openRows: ObservableSet;
}

export const XeroSyncHistoryItemIcons = observer(
  ({ openRows, operation }: XeroSyncHistoryItemIconsProps) => {
    if (operation.index !== 0) return null;

    const xeroUrl = getXeroLinkUrl(operation);

    const isOpen = openRows.has(operation.id);
    const onClick = action(() => {
      if (isOpen) {
        openRows.delete(operation.id);
      } else {
        openRows.add(operation.id);
      }
    });
    return (
      <Stack horizontal tokens={{ childrenGap: 16 }} verticalAlign="center">
        <StackItem styles={{ root: { width: 16 } }}>
          {operation.hasChildren && (
            <Link onClick={onClick}>
              <FontIcon
                styles={{ root: { marginTop: 4 } }}
                iconName={isOpen ? "DoubleChevronUp" : "DoubleChevronDown"}
              />
            </Link>
          )}
        </StackItem>
        <StackItem styles={{ root: { width: 16 } }}>
          {xeroUrl && (
            <Link href={xeroUrl} target="_blank">
              <Image
                width="154.4"
                height="27"
                src={openInNewTabSvg}
                alt="Xero logo"
              />
            </Link>
          )}
        </StackItem>
      </Stack>
    );
  }
);
